import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {Site, SiteAddReq, SiteMoveReq, Sites, SiteUpdateReq} from '../types/site';

/**
 * SiteServiceApi - axios parameter creator
 * @export
 */
export const SiteServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 添加站点
     * @summary 添加站点
     * @param {SiteAddReq} siteAddReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceAdd: async (
      siteAddReq: SiteAddReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteAddReq' is not null or undefined
      assertParamExists('siteServiceAdd', 'siteAddReq', siteAddReq);
      const localVarPath = `/site/site`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        siteAddReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 删除站点
     * @summary 删除站点
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('siteServiceDelete', 'id', id);
      const localVarPath = `/site/site/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 查询所有祖先
     * @summary 查询所有祖先
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceFindAncestors: async (
      orgId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/site/site_ancestors`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 查询所有子孙后代
     * @summary 查询所有子孙后代
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceFindDescendants: async (
      orgId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/site/site_descendants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @summary 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @param {string} [orgId]
     * @param {SiteServiceListSiteTypeEnum} [siteType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceList: async (
      orgId?: string,
      siteType?: SiteServiceListSiteTypeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/site/sites`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (siteType !== undefined) {
        localVarQueryParameter['siteType'] = siteType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 移动站点
     * @summary 移动站点
     * @param {string} siteId
     * @param {SiteMoveReq} siteMoveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceMove: async (
      siteId: string,
      siteMoveReq: SiteMoveReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('siteServiceMove', 'siteId', siteId);
      // verify required parameter 'siteMoveReq' is not null or undefined
      assertParamExists('siteServiceMove', 'siteMoveReq', siteMoveReq);
      const localVarPath = `/site/site/{siteId}/move`.replace(
        `{${'siteId'}}`,
        encodeURIComponent(String(siteId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        siteMoveReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 获取站点树   获取一颗完整的站点树
     * @summary 获取站点树   获取一颗完整的站点树
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceTree: async (
      orgId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/site/site_trees`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 更新站点信息
     * @summary 更新站点信息
     * @param {string} siteId
     * @param {SiteUpdateReq} siteUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceUpdate: async (
      siteId: string,
      siteUpdateReq: SiteUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('siteServiceUpdate', 'siteId', siteId);
      // verify required parameter 'siteUpdateReq' is not null or undefined
      assertParamExists('siteServiceUpdate', 'siteUpdateReq', siteUpdateReq);
      const localVarPath = `/site/site/{siteId}`.replace(
        `{${'siteId'}}`,
        encodeURIComponent(String(siteId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        siteUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SiteServiceApi - functional programming interface
 * @export
 */
export const SiteServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SiteServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 添加站点
     * @summary 添加站点
     * @param {SiteAddReq} siteAddReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceAdd(
      siteAddReq: SiteAddReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceAdd(siteAddReq, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceAdd']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 删除站点
     * @summary 删除站点
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 查询所有祖先
     * @summary 查询所有祖先
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceFindAncestors(
      orgId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sites>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceFindAncestors(
        orgId,
        siteId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceFindAncestors']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 查询所有子孙后代
     * @summary 查询所有子孙后代
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceFindDescendants(
      orgId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sites>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceFindDescendants(
        orgId,
        siteId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceFindDescendants']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @summary 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @param {string} [orgId]
     * @param {SiteServiceListSiteTypeEnum} [siteType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceList(
      orgId?: string,
      siteType?: SiteServiceListSiteTypeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sites>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceList(
        orgId,
        siteType,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceList']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 移动站点
     * @summary 移动站点
     * @param {string} siteId
     * @param {SiteMoveReq} siteMoveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceMove(
      siteId: string,
      siteMoveReq: SiteMoveReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceMove(
        siteId,
        siteMoveReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceMove']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 获取站点树   获取一颗完整的站点树
     * @summary 获取站点树   获取一颗完整的站点树
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceTree(
      orgId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceTree(orgId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceTree']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 更新站点信息
     * @summary 更新站点信息
     * @param {string} siteId
     * @param {SiteUpdateReq} siteUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteServiceUpdate(
      siteId: string,
      siteUpdateReq: SiteUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteServiceUpdate(
        siteId,
        siteUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SiteServiceApi.siteServiceUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SiteServiceApi - factory interface
 * @export
 */
export const SiteServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SiteServiceApiFp(configuration);
  return {
    /**
     * 添加站点
     * @summary 添加站点
     * @param {SiteAddReq} siteAddReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceAdd(siteAddReq: SiteAddReq, options?: any): AxiosPromise<IdRsp> {
      return localVarFp
        .siteServiceAdd(siteAddReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 删除站点
     * @summary 删除站点
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.siteServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 查询所有祖先
     * @summary 查询所有祖先
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceFindAncestors(orgId?: string, siteId?: string, options?: any): AxiosPromise<Sites> {
      return localVarFp
        .siteServiceFindAncestors(orgId, siteId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 查询所有子孙后代
     * @summary 查询所有子孙后代
     * @param {string} [orgId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceFindDescendants(
      orgId?: string,
      siteId?: string,
      options?: any
    ): AxiosPromise<Sites> {
      return localVarFp
        .siteServiceFindDescendants(orgId, siteId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @summary 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
     * @param {string} [orgId]
     * @param {SiteServiceListSiteTypeEnum} [siteType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceList(
      orgId?: string,
      siteType?: SiteServiceListSiteTypeEnum,
      options?: any
    ): AxiosPromise<Sites> {
      return localVarFp
        .siteServiceList(orgId, siteType, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 移动站点
     * @summary 移动站点
     * @param {string} siteId
     * @param {SiteMoveReq} siteMoveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceMove(siteId: string, siteMoveReq: SiteMoveReq, options?: any): AxiosPromise<void> {
      return localVarFp
        .siteServiceMove(siteId, siteMoveReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 获取站点树   获取一颗完整的站点树
     * @summary 获取站点树   获取一颗完整的站点树
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceTree(orgId?: string, options?: any): AxiosPromise<Site> {
      return localVarFp.siteServiceTree(orgId, options).then(request => request(axios, basePath));
    },
    /**
     * 更新站点信息
     * @summary 更新站点信息
     * @param {string} siteId
     * @param {SiteUpdateReq} siteUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteServiceUpdate(
      siteId: string,
      siteUpdateReq: SiteUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .siteServiceUpdate(siteId, siteUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * SiteServiceApi - object-oriented interface
 * @export
 * @class SiteServiceApi
 * @extends {BaseAPI}
 */
export class SiteServiceApi extends BaseAPI {
  /**
   * 添加站点
   * @summary 添加站点
   * @param {SiteAddReq} siteAddReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceAdd(siteAddReq: SiteAddReq, options?: RawAxiosRequestConfig) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceAdd(siteAddReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 删除站点
   * @summary 删除站点
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 查询所有祖先
   * @summary 查询所有祖先
   * @param {string} [orgId]
   * @param {string} [siteId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceFindAncestors(
    orgId?: string,
    siteId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceFindAncestors(orgId, siteId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 查询所有子孙后代
   * @summary 查询所有子孙后代
   * @param {string} [orgId]
   * @param {string} [siteId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceFindDescendants(
    orgId?: string,
    siteId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceFindDescendants(orgId, siteId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
   * @summary 获取站点列表   可以根据站点属性进行过滤  结果是所拥有的站点列表
   * @param {string} [orgId]
   * @param {SiteServiceListSiteTypeEnum} [siteType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceList(
    orgId?: string,
    siteType?: SiteServiceListSiteTypeEnum,
    options?: RawAxiosRequestConfig
  ) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceList(orgId, siteType, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 移动站点
   * @summary 移动站点
   * @param {string} siteId
   * @param {SiteMoveReq} siteMoveReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceMove(
    siteId: string,
    siteMoveReq: SiteMoveReq,
    options?: RawAxiosRequestConfig
  ) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceMove(siteId, siteMoveReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 获取站点树   获取一颗完整的站点树
   * @summary 获取站点树   获取一颗完整的站点树
   * @param {string} [orgId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceTree(orgId?: string, options?: RawAxiosRequestConfig) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceTree(orgId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 更新站点信息
   * @summary 更新站点信息
   * @param {string} siteId
   * @param {SiteUpdateReq} siteUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteServiceApi
   */
  public siteServiceUpdate(
    siteId: string,
    siteUpdateReq: SiteUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return SiteServiceApiFp(this.configuration)
      .siteServiceUpdate(siteId, siteUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const SiteServiceListSiteTypeEnum = {
  UnknownType: 'unknown_type',
  NodeType: 'node_type',
  ApartmentType: 'apartment_type',
  LocationType: 'location_type',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SiteServiceListSiteTypeEnum =
  (typeof SiteServiceListSiteTypeEnum)[keyof typeof SiteServiceListSiteTypeEnum];
